import React, { useState } from "react";
import { Box, Typography, Grid, CircularProgress, Divider, FormLabel } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { ClearRounded, SaveRounded } from "@mui/icons-material";
import CustomButton from "../../common/CustomButton";
import CustomTextField from "../../common/CustomTextField";
import { genericPost } from '../../../services/authServices';
import { CREATE_IMPORT_SHIPPING_MARK } from '../../../services/apiRoutes';
import CustomAutocomplete from "../../common/CustomAutoComplete";
import CustomStyle from "../../common/CustomStyle";
import { Editor } from "react-draft-wysiwyg";
import { stateToHTML } from "draft-js-export-html";
import draftToHtml from 'draftjs-to-html';
import { EditorState, convertFromHTML, ContentState, convertToRaw } from "draft-js";


import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { t } from "../../../constants/translationHelper";

const ValidationSchema = Yup.object().shape({
    batchNo: Yup.string().required('Batch Number is required'),
    productId: Yup.number().required('Product is required'),
});

const CreateShippingMark = ({ handleClose, setMessage, fetchData, productsList, fetchButtonList, clientCompanyId, shipmentOrgId, commanShipmentId, importShipmentId, shipmentId }) => {
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const onEditorStateChange = (state) => {
        setEditorState(state);
    };
    const convertToHTMLContent = () => {
        const contentState = editorState.getCurrentContent();
        // const htmlContent = stateToHTML(contentState);
        const htmlContent = draftToHtml(convertToRaw(contentState));

        return htmlContent;
    };


    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const htmlContent = convertToHTMLContent();
            const shippingMark = htmlContent;
            const payload = {
                shipmentOrgId: values.shipmentOrgId,
                commanShipmentId: values.commanShipmentId,
                importShipmentId: values.importShipmentId,
                clientCompanyId: values.clientCompanyId,
                shipmentId: values.shipmentId,
                batchNo: values.batchNo,
                productId: values.productId,
                shippingMark: shippingMark
            };
            console.log('Shipping Mark Data:', values.shippingMark);

            const response = await genericPost(CREATE_IMPORT_SHIPPING_MARK, payload);

            if (response.status === 201) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "Shipping mark added successfully",
                    type: "success",
                });
                setTimeout(() => {
                    fetchData();
                    fetchButtonList();
                    handleClose();
                }, 1000);
            }
            else if (response.status === 409) {
                setMessage({
                    open: true,
                    text: response.message || 'already exists ',
                    type: 'error',
                });
            }
            else {
                alert('Something went wrong');
            }
        } catch (error) {
            alert('Something went wrong');
        } finally {
            setSubmitting(false);
        }
    };
    const [formData] = useState({
        commanShipmentId: commanShipmentId,
        clientCompanyId: clientCompanyId,
        importShipmentId: importShipmentId,
        shipmentOrgId: shipmentOrgId,
        shipmentId: shipmentId,
        batchNo: '',
        productId: '',
        shippingMark: '',
    });

    return (
        <Box sx={{ mx: 'auto', mt: 0 }}>
            <Formik
                initialValues={formData}
                validationSchema={ValidationSchema}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting, errors, touched, handleChange, setFieldValue, values }) => (
                    <Form>
                        <Grid container spacing={1} style={CustomStyle.container}>
                            <Grid item xs={4} md={4}>
                                <Typography sx={{ fontWeight: 600 }} style={CustomStyle.title}>
                                    {t("Create Shipping Mark")}
                                </Typography>
                            </Grid>
                            <Grid item xs={8} md={8} style={CustomStyle.buttonContainer}>
                                <Box style={CustomStyle.buttonBox}>
                                    <CustomButton
                                        startIcon={<SaveRounded />}
                                        title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                                        size="small"
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting}
                                    />
                                    <CustomButton
                                        startIcon={<SaveRounded />}
                                        title=" Save and New"
                                        size="small"
                                        variant="contained"
                                    />
                                    <CustomButton
                                        startIcon={<ClearRounded />}
                                        title="Cancel"
                                        size="small"
                                        variant="contained"
                                        onClick={handleClose}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid container spacing={2} sx={{ px: "5%", paddingTop: "5px" }}>
                            <Grid item xs={12} md={6}>
                                <CustomTextField
                                    placeholder="Enter Batch Number"
                                    name="batchNo"
                                    fieldLabel="Batch Number"
                                    required={true}
                                    value={values.batchNo}
                                    onChange={handleChange}
                                    error={touched.batchNo && !!errors.batchNo}
                                    helperText={touched.batchNo && errors.batchNo}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <CustomAutocomplete
                                    options={productsList}
                                    fieldLabel="Select Product"
                                    required={true}
                                    getOptionLabel={(option) => option.title}
                                    value={productsList.find((option) => option.id === values.productId) || null}
                                    onChange={(e, newValue) =>
                                        setFieldValue('productId', newValue ? newValue.id : '')
                                    }
                                    placeholder="Select Product"
                                    error={touched.productId && !!errors.productId}
                                    helperText={touched.productId && errors.productId}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormLabel sx={{ paddingBottom: "10px" }} style={fieldLabelstyle}>{t("Shipping Mark")}</FormLabel>
                                <Editor
                                    editorState={editorState}


                                    onEditorStateChange={onEditorStateChange}
                                    wrapperClassName="demo-wrapper"
                                    editorClassName="demo-editor"
                                    wrapperStyle={{
                                        border: '1px solid #CED4DA', borderRadius: '4px',
                                    }}
                                    editorStyle={{ padding: "10px" }}
                                    toolbar={{
                                        options: [
                                            'inline',
                                            'blockType',
                                            'fontSize',
                                            'fontFamily',
                                            'list',
                                            'textAlign',
                                            'colorPicker',
                                            'link',
                                            'emoji',
                                            'remove',
                                            'history'
                                        ],
                                        inline: {
                                            inDropdown: false,
                                            options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
                                        },
                                        blockType: {
                                            inDropdown: true,
                                            options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code'],
                                        },
                                        fontSize: {
                                            options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                                        },
                                        list: {
                                            inDropdown: false,
                                            options: ['unordered', 'ordered', 'indent', 'outdent'],
                                        },
                                        textAlign: {
                                            inDropdown: false,
                                            options: ['left', 'center', 'right', 'justify'],
                                        },
                                        link: {
                                            inDropdown: false,
                                            options: ['link', 'unlink'],
                                        },
                                        history: {
                                            inDropdown: false,
                                            options: ['undo', 'redo'],
                                        },
                                    }}

                                />
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};

export default CreateShippingMark;
const fieldLabelstyle = {
    color: "#212529",
    fontWeight: "600",
    fontSize: "14px",
};

